import cx from "classnames";
import { AriaRole } from "react";

import TextEllipsis from "ds/components/TextEllipsis";
import Typography, { TypographyProps } from "ds/components/Typography";
import { TooltipProps } from "ds/components/Tooltip/types";

type ListEntitiesItemTitleProps = {
  title: string;
  titleTag?: TypographyProps["tag"];
  titleVariant?: TypographyProps["variant"];
  titleColor?: TypographyProps["color"];
  tooltip?: string;
  tooltipWidthMode?: TooltipProps["widthMode"];
  className?: string;
  role?: AriaRole;
};

const ListEntitiesItemTitle = ({
  title,
  titleTag = "span",
  titleColor,
  tooltip = title,
  tooltipWidthMode = "maxWidthSm",
  className,
  role,
}: ListEntitiesItemTitleProps) => {
  return (
    <TextEllipsis tooltip={tooltip} tooltipWidthMode={tooltipWidthMode}>
      {(props) => (
        <Typography
          {...props}
          variant="p-t7"
          tag={titleTag}
          role={role}
          className={cx(props.className, className)}
          color={titleColor}
        >
          {title}
        </Typography>
      )}
    </TextEllipsis>
  );
};

export default ListEntitiesItemTitle;
